import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Requests extends ChemComponent {
	constructor(props) {
		super(props);

		var search = {
			REQUESTDATE_FROM: null,
			REQUESTDATE_TO: null,
			DATECOMP_FROM: null,
			DATECOMP_TO: null,
			BILLINGDATE: null,
			STATUS: [],
			COMPLETE: null
		};
		
		if (props.search) {
			var propsSearch = this.copyObject(props.search);
			this.mergeObject(search, propsSearch);
			search = propsSearch;
		}
		
		var requestListInit = this.copyTable(requestList);
		requestListInit.query.search = this.constructSearch(search);

		this.state = {
			requestList: requestListInit,
			archive: {
				BILLINGDATE: null
			},
			search: search,
			searchCount: null,
			renderKey: 0
		};
	}
	
	componentDidUpdate(prevProps) {
		if (this.state.search.treeMenuClickCount !== this.props.search.treeMenuClickCount) {
			var newRequestList = this.copyTable(requestList);
			newRequestList.query.search = this.constructSearch(this.props.search);
			this.mergeState({
				requestList: newRequestList,
				search: this.copyObject(this.props.search),
				searchCount: null,
				renderKey: this.state.renderKey + 1
			});
		}
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.ID)) search.Children.push({ Attribute: 'ID', Operator: '=', LongValue: data.ID });
		if (!this.isEmpty(data.NAME)) search.Children.push({ Attribute: 'NAME_UCASE', Operator: 'like',
			StringValue: '%' + data.NAME.toUpperCase() + '%' });
		if (!this.isEmpty(data.REQUESTDATE_FROM)) search.Children.push({ Attribute: 'REQUESTDATE', Operator: '>=', DateValue: data.REQUESTDATE_FROM });
		if (!this.isEmpty(data.REQUESTDATE_TO)) search.Children.push({ Attribute: 'REQUESTDATE', Operator: '<', DateValue: this.nextDayMVC(data.REQUESTDATE_TO) });
		if (!this.isEmpty(data.DATECOMP_FROM)) search.Children.push({ Attribute: 'DATECOMP', Operator: '>=', DateValue: data.DATECOMP_FROM });
		if (!this.isEmpty(data.DATECOMP_TO)) search.Children.push({ Attribute: 'DATECOMP', Operator: '<', DateValue: this.nextDayMVC(data.DATECOMP_TO) });
		if (!this.isEmpty(data.BILLINGDATE)) {
			if (data.BILLINGDATE === 'NOTBILLED') {
				search.Children.push({ Attribute: 'BILLINGDATE', Operator: 'is null' });
			} else {			
				search.Children.push({ Attribute: 'BILLINGDATE', Operator: '=', DateValue: this.dateTimeToMVC(this.getDate(data.BILLINGDATE)) });
			}
		}
		if (!this.isEmpty(data.STATUS)) search.Children.push({ Attribute: 'STATUS', Operator: 'in', StringList: data.STATUS });
		if (!this.isEmpty(data.COMPLETE)) {
			if (data.COMPLETE === 1) {
				search.Children.push({ Attribute: 'COMPLETE', Operator: '=', LongValue: 1 });
			} else {
				search.Children.push({ Attribute: 'COMPLETE', Operator: 'is null' });
			}
		}
		
		// if there are no terms, forget it
		if (search.Children.length === 0) search = null;
		return search;
	}

	onSubmitSearch(event) {
		var newRequestList = this.copyTable(requestList);
		newRequestList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			requestList: newRequestList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	addRequest() {
		this.props.navigate('/FAS/AddRequest');
	}
	
	editRequest(facilitiesId, requestId) {
		if (facilitiesId === 34) {
			this.props.navigate('/FAS/Microrequests/' + requestId);
		} else if (facilitiesId === 33) {
			this.props.navigate('/FAS/Xrayrequests/' + requestId);
		}
	}
	
	onClickArchive() {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/FAS/Archive',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				search: this.constructSearch(this.state.search),
				billingdate: this.state.archive.BILLINGDATE
			}
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					return (<>{data.Message}</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Requests',
			columns: exportColumns,
			entity: 'FAS.REQUESTS_VW',
			search: this.constructSearch(this.state.search),
			order: 'REQUESTDATE desc'
		});			

		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Requests</div>
						<Container fluid>
						  <Row>
						    <Col xs={9}>
							  <ChemEdit parent={this} user={this.props.user} columns={requestSearch} data={this.state.search}
								renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
							</Col>
							<Col xs={3}>
							  <ChemEdit parent={this} user={this.props.user} columns={statusSearch} data={this.state.search}
								renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
							</Col>
						  </Row>
						</Container>
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={2} style={{ marginTop: 10 }}>
						<div className='float-end'>Date Billed</div>
					  </Col>
					  <Col xs={2} style={{ marginTop: 6 }}>
					    <DatePicker
						  selected={this.getDate(this.state.archive.BILLINGDATE)}
						  onChange={(date) => this.mergeState({ archive: { BILLINGDATE: date === null ? null : this.dateTimeToMVC(date) }})}
						  dateFormat='MM/dd/yy'
					    />
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Archive</Popover.Header></Popover>}>
						  <input type='image' src={this.getConfig().host + '/Content/Icons/archive.png'} style={{ paddingLeft: '20px' }} alt="Archive" onClick={() => this.onClickArchive()} />
						</OverlayTrigger>
					  </Col>
					  <Col xs={2}>
						<Button id="search" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='FAS_Requests' table={this.state.requestList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='330px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const requestSearch = [
	{ Header: 'Request No.', accessor: 'ID', row: 0, col: 0 },
	{ Header: 'Requested By', accessor: 'NAME', row: 0, col: 1 },
	{ Header: 'Request Date From', accessor: 'REQUESTDATE_FROM', type: 'date', row: 1, col: 0 },
	{ Header: 'Request Date To', accessor: 'REQUESTDATE_TO', type: 'date', row: 1, col: 1 },
	{ Header: 'Complete Date From', accessor: 'DATECOMP_FROM', type: 'date', row: 2, col: 0 },
	{ Header: 'Complete Date To', accessor: 'DATECOMP_TO', type: 'date', row: 2, col: 1 },
	{ Header: 'Billing Date', accessor: 'BILLINGDATE', type: 'select', row: 3, col: 0,
		options: { value: 'BILLINGDATE', label: 'BILLINGDATEDISPLAY', entity: 'FAS.BILLINGDATE_SELECT_VW', order: ['BILLEDORDER','BILLINGDATE desc']}},
	{ Header: 'Request Complete', accessor: 'COMPLETE', type: 'select', row: 3, col: 1,
		options: [{ value: null, label: 'All' },{ value: 0, label: 'No' },{ value: 1, label: 'Yes' }]}
];

const statusSearch = [		
	{ Header: 'Status', accessor: 'STATUS', type: 'list', row: 0, col: 0,
		options: [
			{ value: 'Saved', label: 'Saved' },
			{ value: 'Submitted', label: 'Submitted' },
			{ value: 'Updated', label: 'Updated' },
			{ value: 'Completed', label: 'Completed' },
			{ value: 'Archived', label: 'Archived' }
		]
	}
];

const requestList = {
	query: { entity: 'FAS.REQUESTS_VW', search: null, order: 'REQUESTDATE desc' },
	pageSize: 20,
	columns: [
		{ Header: '', accessor: 'FACILITIESID', show: false },
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }}
				onClick={() => props.parent.addRequest()} />, accessor: 'ID', width: 25,
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} 
				onClick={() => props.parent.editRequest(props.row.values.FACILITIESID, props.value)} /> },
		{ Header: 'Request No.', accessor: 'IDDISPLAY', width: 100 },
		{ Header: 'Requester Name', accessor: 'NAME', width: 250 },
		{ Header: 'Facility', accessor: 'CODE', width: 80 },
		{ Header: 'Service', accessor: 'SERVICE', width: 125 },
		{ Header: 'Status', accessor: 'STATUS', width: 100 },
		{ Header: 'Complete Date', accessor: 'DATECOMPDISPLAY', width: 100 },
		{ Header: 'Billing Date', accessor: 'BILLINGDATEDISPLAY', width: 100 }
	]
};

const exportColumns = [
	{ Header: 'Request', accessor: 'IDDISPLAY', width: 12 },
	{ Header: 'Date', accessor: 'REQUESTDATEDISPLAY', width: 12 },
	{ Header: 'Speedtype', accessor: 'SPEEDCODE', width: 15 },
	{ Header: 'PO', accessor: 'PONUMBER', width: 40 },
	{ Header: 'Name', accessor: 'NAME', width: 20 },
	{ Header: 'PI', accessor: 'PINAME', width: 20 },
	{ Header: 'Qty', accessor: 'SERVICEAMOUNT', width: 6 },
	{ Header: 'Labor', accessor: 'LABOR', width: 8 },
	{ Header: 'Material', accessor: 'MATERIAL', width: 10 },
	{ Header: 'Total', accessor: 'SERVICETOTAL', width: 10 },
	{ Header: 'Sample', accessor: 'SAMPLECODE', width: 30 },
	{ Header: 'Service', accessor: 'SERVICE', width: 15 },
	{ Header: 'Lab', accessor: 'LAB', width: 12 },
	{ Header: 'Billed', accessor: 'BILLINGDATEEXPORT', width: 12 }
];

export default withRouter(Requests);
